export default __webpack_public_path__ + "static/media/logo111.4999429a.png";